import styled from "styled-components";

import { NotificationStyledProps as Props } from "./Notification.types";
import { NotificationPlaceholderProps as PlaceholderProps } from "./Notification.types";

const NotificationStyled = styled.div<Props>`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-areas: "icon title" "icon description";
  column-gap: 2rem;
  row-gap: 0.4rem;

  .Notification {
    &__icon-container {
      grid-area: icon;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 4.4rem;
      height: 4.4rem;
      border-radius: 12rem;
      background-color: ${props =>
        props.read
          ? "var(--palette-gray-s0-l74)"
          : "var(--palette-green-s63-l42)"};
      transition: all 1s ease-in-out 5s;
    }

    &__icon {
      path {
        fill: var(--palette-white);
      }
    }

    &__title {
      grid-area: title;
      font-size: 1.6rem;
      line-height: 2.4rem;
      font-weight: 500;
      color: var(--palette-white);
      transition: all 1s ease-in-out 5s;
    }

    &__description {
      grid-area: description;
      font-size: 1.2rem;
      line-height: 1.6rem;
      font-weight: 400;
      color: var(--palette-gray-s0-l80);
    }

    &__link,
    &__link:visited,
    &__link:active,
    &__link:hover {
      color: "var(--gray-s0-l35)";
      font-weight: 700;
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

export const NotificationPlaceholderStyled = styled.div<PlaceholderProps>`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-areas: "icon title" "icon description";
  column-gap: 2rem;
  row-gap: 0.4rem;

  .NotificationPlaceholder {
    &__icon {
      grid-area: icon;
      width: 4.4rem;
      height: 4.4rem;
      border-radius: 12rem;
      background-color: var(--palette-gray-s0-l30);
      overflow: hidden;
    }

    &__title {
      grid-area: title;
      width: 16rem;
      height: 2rem;
      background-color: var(--palette-gray-s0-l30);
      border-radius: 0.4rem;
      overflow: hidden;
    }

    &__description {
      grid-area: description;
      width: 18.4rem;
      height: 2rem;
      background-color: var(--palette-gray-s0-l30);
      border-radius: 0.4rem;
      overflow: hidden;
    }
  }
`;

export default NotificationStyled;
